import React, { useEffect, useState } from 'react';
import './PdfPreview.scss';

const PdfPreview = (properties) => {
  const [Component, setComponent] = useState(null);
  useEffect(() => {
    import('./PdfPreview').then((module_) => setComponent(module_.default));
  }, []);
  if (!Component) {
    return null;
  }
  return <Component {...properties} />;
};

export default PdfPreview;
